/**
 * Hollowing UI
 */
HollowingUI = function (
  hollow_id,
  script_id,
  text_id,
  hollow_script,
  scale_limit
) {
  if (!hollow_id || !script_id || !text_id || !hollow_script) {
    console.log("Hollowing UI: Paramter is missing");

    return null;
  }

  this.args_hollow = {
    id: hollow_id,
    need_html: 0,
  };

  this.args_script = {
    id: script_id,
    language: "template/javascript",
    script: hollow_script,
    "cones.type": text_id,
    "cones.description_en": "cones",
    "cones.value_var": "cones",
    "cones.value": "[]",
    "cones.locked": "True",
    locked_fields: "script",
    force_locked_fields: "",
    need_html: 0,
  };

  this.scale_limit = scale_limit;

  this.viewer = null;

  this.hole_design = null;
  this.hole_node = null;

  this.design_warnings = [];
  this.have_one_hole = 0;
  this.not_hollowed = 0;

  this.orig_design = null;

  // This.origModelNode = null;

  this.shell_design = null;
  this.shell_node = null;

  this.options = null;

  this.cursorON = false;
  this.addHoles = false;
  this.holeModified = false;
  this.holesCreated = false;
  this.dfd_create_holes = null;
  this.allow_update_sliders = true;

  this.cylinderNumber = 0;

  this.minWallThickness = -0.1;
  this.maxWallThickness = -1;
  this.stepWallThickness = 0.01;
  this.defaultWallThickness = -0.3;

  this.minGridStep = 20;
  this.maxGridStep = 300;
  this.stepGridStep = 1;
  this.defaultGridStep = 61;

  this.minHoleWidth = 0.3;
  this.maxHoleWidth = 5;
  this.stepHoleWidth = 0.01;
  this.defaultHoleWidth = 0.4;

  this.minHoleDepth = 0;
  this.maxHoleDepth = 10;
  this.stepHoleDepth = 0.01;
  this.defaultHoleDepth = 0.1;

  this.minHoleHeight = 0;
  this.maxHoleHeight = 5;
  this.stepHoleHeight = 0.01;
  this.defaultHoleHeight = 0.1;

  this.selectedHole = null;
  this.cursor_material =
    "full_a3388bb_d4499ee_s000000_e000000_t000000_x10000_i1_l0";
  this.hole_material = null;
  this.hole_selected_material =
    "full_a3388bb_d4499ee_s000000_e000000_t000000_x10000_i1_l0";

  this.holeCount = 0;
  this.hole_order_list = [];

  this.wireframe = false;

  this.abort = false;
  this.abort_wait = 0;
  this.dfd_abort = null;

  /*
	 Hole_update_type:
	 0 - Update only selected hole
	 1 - Update last created hole
	 2 - Update all holes
	 */
  this.hole_update_type = 0;
};

HollowingUI.prototype = {
  initUI: function (viewer, design, options) {
    var _this = this;

    _this.viewer = viewer;
    _this.orig_design = design;
    _this.options = options;

    $.extend(_this, options);

    if (_this.orig_design.partitioning) {
      _this.parts = _this.orig_design.partitioning.parts;
    } else {
      _this.parts = [_this.orig_design];
    }

    for (var did in _this.parts) {
      var design = _this.parts[did];
      if (design.baseNode) {
        design.node = design.baseNode;
      }

      design.hollowing = {
        design: null,
        modelNode: null,
        op_hollow: null,
        op_script: null,
        orig_op_hollow: null,
        orig_op_script: null,
        origDesignScale: 0,
        scaleFactor: 0,
        userScaleFactor: 0,
        designDiag: 0,
        wallThickness: _this.defaultWallThickness,
        gridStep: _this.defaultGridStep,
        holeWidth: _this.defaultHoleWidth,
        holeDepth: _this.defaultHoleDepth,
        holeHeight: _this.defaultHoleHeight,
        hole_container: null,
        holeList: [],
        holeCount: 0,
        error_too_small: false,
        abort: false,
        abort_wait: 0,
        dfd_abort: null,
      };
    }

    if (options["remove_holes"]) {
      _this.viewer.setLocal(true);
      var part_dfds = [];

      for (var did in _this.parts) {
        var design = _this.parts[did];
        var part_dfd = $.Deferred();

        part_dfds.push(part_dfd);

        design.hollowing.orig_op_hollow = design.get_operation(
          "HollowDesignOperation"
        );

        if (design.hollowing.orig_op_hollow) {
          design.hollowing.orig_op_script = design.get_operation_by_seq(
            design.hollowing.orig_op_hollow.seq + 1
          );
        }

        (function (design, part_dfd) {
          _this.remove_orig_operations(design).then(function () {
            var name = design.node ? design.node.id : null;

            design.load_in_viewer(_this.viewer, name).then(function () {
              _this.viewer.setLocal(false);
              part_dfd.resolve();
            });
          });
        })(design, part_dfd);
      }

      var dfd = $.Deferred();

      $.when.apply(null, part_dfds).then(function () {
        dfd.resolve();
      });

      return dfd.promise();
    }

    if (options["update_scale"]) {
      _this.viewer.setLocal(true);

      var hollowing_disabled = 0;
      var design_too_small = 0;
      var design_modified = false;

      var part_dfds = [];

      for (var did in _this.parts) {
        var design = _this.parts[did];
        var part_dfd = $.Deferred();

        part_dfds.push(part_dfd);

        (function (design, part_dfd) {
          // Fetch original design operations
          design.hollowing.orig_op_hollow = design.get_operation(
            "HollowDesignOperation"
          );

          if (design.hollowing.orig_op_hollow) {
            design.hollowing.orig_op_script = design.get_operation_by_seq(
              design.hollowing.orig_op_hollow.seq + 1
            );
          }

          // Update hollowing paramaters from the operations
          design.hollowing.designDiag = Math.sqrt(
            design.size.x * design.size.x +
              design.size.y * design.size.y +
              design.size.z * design.size.z
          );
          design.hollowing.gridStep = Math.round(
            design.hollowing.designDiag /
              design.hollowing.orig_op_hollow.data.step
          );

          // Initilaize hole paramaters from the script operation data
          if (design.hollowing.orig_op_script.data.cones.length > 0) {
            var cones = eval(design.hollowing.orig_op_script.data.cones);

            if (cones.length > 0) {
              var add = cones.shift();

              design.hollowing.wallThickness = cones.shift();
              design.hollowing.scaleFactor = cones.shift();

              var offset = 19;
              var ncones = cones.length / offset;

              for (var i = 0; i < ncones; ++i) {
                var node = {};

                node.hole_width =
                  cones[offset * i + 0] * design.hollowing.scaleFactor;
                node.hole_depth =
                  cones[offset * i + 1] * design.hollowing.scaleFactor;
                node.hole_height =
                  cones[offset * i + 2] * design.hollowing.scaleFactor;
                node.transform = new Sculpteo3DViewerCommonTransform3D(
                  cones.slice(offset * i + 3, offset * i + 19)
                );
                design.hollowing.holeList.push(node);
              }
            }
          }

          // If material was modified, update the wall thikness and hole threashold
          // TODO: If the values were modified by staff, do some additional checks
          var material = options["update_material"];
          var modif = false;

          if (material) {
            if (!material.wall_thickness) {
              design.hollowing.wallThickness = 0;
            } else {
              if (
                design.hollowing.wallThickness !=
                -material.wall_thickness * design.size.units["mm"]
              ) {
                design.hollowing.wallThickness =
                  -material.wall_thickness * design.size.units["mm"];
                modif = true;
              }
            }

            if (!material.hole_threshold) {
              design.hollowing.holeWidth = 0;
            } else {
              if (design.hollowing.holeList.length > 0) {
                design.hollowing.holeWidth =
                  design.hollowing.holeList[0].hole_width;

                if (
                  design.hollowing.holeWidth !=
                  material.hole_threshold * design.size.units["mm"]
                ) {
                  design.hollowing.holeWidth =
                    material.hole_threshold * design.size.units["mm"];

                  // Update the width of all holes
                  // TODO: If holes have all different width, do some additional checks
                  for (var i = 0; i < design.hollowing.holeList.length; ++i) {
                    design.hollowing.holeList[i].hole_width =
                      design.hollowing.holeWidth;
                  }

                  modif = true;
                }
              }
            }
          }

          // Check for scale modifications and update
          design.hollowing.origDesignScale = design.size.userScale;
          design.hollowing.userScaleFactor =
            design.size.userScale * design.size.units[design.size.unit];

          if (
            design.hollowing.scaleFactor !=
            design.hollowing.origDesignScale *
              design.size.units[design.size.unit]
          ) {
            design.hollowing.scaleFactor =
              design.hollowing.origDesignScale *
              design.size.units[design.size.unit];
            modif = true;
          }

          design_modified = modif;

          var step = design.hollowing.designDiag / design.hollowing.gridStep;
          var minStep =
            -design.hollowing.wallThickness /
            design.hollowing.userScaleFactor /
            2.0;

          if (step > minStep) {
            design.hollowing.gridStep = Math.round(
              design.hollowing.designDiag / minStep
            );
          }

          function disable_hollowing(msg) {
            // Disable hollowing operations and reload design
            design.hollowing.orig_op_hollow
              .modify({ enabled: false })
              .then(function () {
                design.hollowing.orig_op_script
                  .modify({ enabled: false })
                  .then(function () {
                    var name = design.node ? design.node.id : null;

                    design.load_in_viewer(_this.viewer, name).then(function () {
                      part_dfd.hollow_active = false;
                      part_dfd.resolve(false);
                    });
                  });
              });
          }

          // Check if the design is to small for hollowing
          // if yes, don't ask the server at all to perform it
          var do_limit_scale = false;

          if (
            _this.scale_limit &&
            design.hollowing.wallThickness != 0 &&
            design.hollowing.holeWidth != 0
          ) {
            var wall =
              -design.hollowing.wallThickness /
              design.hollowing.userScaleFactor;

            if (
              wall * _this.scale_limit > design.size.x ||
              wall * _this.scale_limit > design.size.y ||
              wall * _this.scale_limit > design.size.z
            ) {
              do_limit_scale = true;
            }
          }

          // Decide here if hollowing is being modified
          var dfd_enable = true;
          var modif_called = false;

          // Check if hollowing should be disabled
          if (
            design.hollowing.wallThickness == 0 ||
            design.hollowing.holeWidth == 0 ||
            do_limit_scale ||
            design.order.finish == "myrtillage" ||
            design.order.finish == "chemical_smoothing"
          ) {
            if (design.hollowing.orig_op_hollow.data.enabled) {
              design_modified = true;

              // If it was enabled, disable it stating the reason
              if (do_limit_scale) {
                disable_hollowing("hollowing_design_too_small");
                design_too_small++;
              } else {
                disable_hollowing("hollowing_disabled");
                hollowing_disabled++;
              }
            } else {
              // If it was disabled, just signal
              if (do_limit_scale) {
                _this.onModification(false, "hollowing_design_too_small");
                design_too_small++;
              } else {
                _this.onModification(false, "hollowing_disabled");
                hollowing_disabled++;
              }

              // And reject the hollowing
              part_dfd.reject();
            }

            return;
          } else if (!design.hollowing.orig_op_hollow.data.enabled) {
            design_modified = true;
            dfd_enable = $.Deferred();

            // Enable operations
            design.hollowing.orig_op_hollow
              .modify({ enabled: true })
              .then(function () {
                design.hollowing.orig_op_script
                  .modify({ enabled: true })
                  .then(function () {
                    if (!modif) {
                      // If parameters were not modified, just load the design
                      var failed = false;
                      var name = design.node ? design.node.id : "model";

                      design.hollowing.modelNode =
                        _this.viewer.getNodesByName(name)[0];

                      // Listen for warnings
                      // If warnings, the listener will be called before load_in_viewer is done
                      design.hollowing.modelNode.addEventListener(
                        "warning",
                        function (msg) {
                          var m = JSON.parse(msg);

                          if (m && m[0].id == "hollowing_design_too_small") {
                            // Make it failed and disable hollowing
                            failed = true;
                            _this.fatal_error_check();
                            _this.onModification(
                              false,
                              "hollowing_design_too_small"
                            );
                            disable_hollowing("hollowing_design_too_small");
                          }
                        }
                      );

                      design
                        .load_in_viewer(_this.viewer, name)
                        .then(function () {
                          design.hollowing.modelNode.removeEventListener(
                            "warnings"
                          );

                          if (!failed) {
                            // Don't update the operations since it will be disabled
                            dfd_enable.reject();
                            part_dfd.hollow_active = true;
                            part_dfd.resolve(true);
                          }
                        });
                    } else {
                      // Update the operations
                      dfd_enable.resolve();
                    }
                  });
              });
          }

          if (modif) {
            // Calculate hole real size
            for (var i = 0; i < design.hollowing.holeList.length; ++i) {
              design.hollowing.holeList[i].hole_width /=
                design.hollowing.scaleFactor;
              design.hollowing.holeList[i].hole_depth /=
                design.hollowing.scaleFactor;
              design.hollowing.holeList[i].hole_height /=
                design.hollowing.scaleFactor;
            }

            $.when(dfd_enable).then(function () {
              // Update operations
              _this
                .updateHollowOperation(design, {
                  active: true,
                  offset: -design.hollowing.wallThickness,
                })
                .then(function () {
                  // Referesh design
                  var failed = false;
                  var name = design.node ? design.node.id : null;

                  design.hollowing.modelNode =
                    _this.viewer.getNodesByName(name)[0];

                  // Listen for warnings
                  // If warnings, the listener will be called before load_in_viewer is done
                  design.hollowing.modelNode.addEventListener(
                    "warnings",
                    function (msg) {
                      var m = JSON.parse(msg);

                      if (m && m[0].id == "hollowing_design_too_small") {
                        // Make it failed and disable hollowing
                        failed = true;
                        _this.fatal_error_check();
                        _this.onModification(
                          false,
                          "hollowing_design_too_small"
                        );
                        disable_hollowing("hollowing_design_too_small");
                      }
                    }
                  );

                  design.load_in_viewer(_this.viewer, name).then(function () {
                    design.hollowing.modelNode.removeEventListener("warnings");

                    if (!failed) {
                      part_dfd.hollow_active = true;
                      part_dfd.resolve(true);
                    }
                  });
                });
            });
          } else {
            // If not modified just reject
            $.when(dfd_enable).then(function () {
              part_dfd.reject();
            });
          }
        })(design, part_dfd);
      }

      if (design_modified) {
        if (part_dfds.length == design_too_small) {
          _this.onModification(false, "hollowing_design_too_small");
        } else if (part_dfds.length == hollowing_disabled) {
          _this.onModification(false, "hollowing_disabled");
        } else {
          _this.onModification(true);
        }
      }

      var dfd = $.Deferred();

      $.when.apply(null, part_dfds).then(
        function () {
          var hollow_active = false;
          var reject = true;

          for (var i in part_dfds) {
            if (part_dfds[i].state() == "resolved") {
              hollow_active |= part_dfds[i].hollow_active;
              reject = false;
            }
          }

          _this.viewer.setLocal(false);

          if (reject) {
            dfd.reject();
          } else {
            dfd.resolve(hollow_active);
          }
        },
        function () {
          if (part_dfds.length == design_too_small) {
            _this.onModification(false, "hollowing_design_too_small");
          } else if (part_dfds.length == hollowing_disabled) {
            _this.onModification(false, "hollowing_disabled");
          }

          _this.viewer.setLocal(false);

          if (design_modified) {
            dfd.resolve(false);
          } else {
            dfd.reject();
          }
        }
      );

      return dfd.promise();
    }

    var gridStep = this.maxGridStep;

    for (var did in this.parts) {
      var design = this.parts[did];

      // Update hole width and wall thickness values depending on material
      if (design.material && design.material.hole_threshold) {
        design.hollowing.holeWidth =
          design.material.hole_threshold * design.size.units["mm"];
        this.minHoleWidth = design.hollowing.holeWidth;
      }

      if (design.material && design.material.wall_thickness) {
        design.hollowing.wallThickness =
          -design.material.wall_thickness * design.size.units["mm"];
        this.minWallThickness = design.hollowing.wallThickness;
      }

      // Calculate scale factor
      if (design.node) {
        var comp = design.node.transform.decompose();

        design.hollowing.origDesignScale = design.size.userScale / comp.scale;
      } else {
        design.hollowing.origDesignScale = design.size.userScale;
      }

      design.hollowing.scaleFactor =
        design.hollowing.origDesignScale * design.size.units[design.size.unit];
      design.hollowing.userScaleFactor =
        design.size.userScale * design.size.units[design.size.unit];

      // Make sure our grid step is big enough so that the wall is generated properly
      design.hollowing.designDiag = Math.sqrt(
        design.size.x * design.size.x +
          design.size.y * design.size.y +
          design.size.z * design.size.z
      );
      var step = design.hollowing.designDiag / design.hollowing.gridStep;
      var minStep =
        -design.hollowing.wallThickness /
        design.hollowing.userScaleFactor /
        2.0;

      if (step > minStep) {
        design.hollowing.gridStep = Math.round(
          design.hollowing.designDiag / minStep
        );
        this.minGridStep = design.hollowing.gridStep;
        this.maxGridStep = gridStep + this.minGridStep;
      }
    }

    // Just init UI (mainly for sliders) and exit
    if (options["init_only_ui"]) {
      _this.initUIComponents(this.parts[0], _this.options);
      _this.deinitUI();

      return true;
    }

    this.viewer.setCSGMode(1);
    this.viewer.bind("keypress", function (code, character) {
      if (character == "w") {
        // Del
        _this.wireframe = !_this.wireframe;
        _this.viewer.setWireframe(_this.wireframe);
      }
    });

    _this.viewer.setStatusMessage(gettext("Loading 3D model"), true, 0);
    _this.initUIComponents(this.parts[0], _this.options);

    // Set hole count to one so that we can detect if there is hollowing allready
    for (var did in this.parts) {
      var design = this.parts[did];
      var op = design.get_operation("HollowDesignOperation");

      if (op) {
        this.holeCount = 1;
        break;
      }
    }

    _this.viewer.setLocal(true);

    var part_dfds = [];

    for (var did in _this.parts) {
      part_dfds[did] = $.Deferred();
    }

    // Generate the hole model
    setTimeout(function () {
      _this.init_hole_model().then(function () {
        // Update operations data and clone the original design
        for (var did in _this.parts) {
          var design = _this.parts[did];
          var part_dfd = part_dfds[did];

          (function (design, part_dfd) {
            design.hollowing.abort_wait++;
            design.fetch_operation(true, false).then(function () {
              design.hollowing.abort_wait--;

              if (design.hollowing.abort) {
                part_dfd.resolve();
                return;
              }

              design.hollowing.abort_wait++;
              design.clone().then(
                function (new_design) {
                  design.hollowing.abort_wait--;

                  if (design.hollowing.abort) {
                    part_dfd.resolve();
                    return;
                  }

                  // Update the clone operations and init everything
                  design.hollowing.design = new_design;
                  design.hollowing.abort_wait++;
                  design.hollowing.design
                    .fetch_operation(true, false)
                    .then(function () {
                      design.hollowing.abort_wait--;

                      if (design.hollowing.abort) {
                        part_dfd.resolve();
                        return;
                      }
                      // Get the model node and register event listeners
                      _this.initModelNode(design);
                      design.hollowing.hole_container =
                        _this.viewer.createNode("hole_container");
                      design.hollowing.modelNode.appendChild(
                        design.hollowing.hole_container,
                        "difference"
                      );

                      // Initilize operations for the clone
                      _this
                        .initOperations(design)
                        .then(function () {
                          // Enable UI interaction
                          part_dfd.resolve();
                        })
                        .fail(function () {
                          design.hollowing.abort = true;
                          design.hollowing.dfd_abort = $.Deferred();
                          part_dfd.resolve();
                        });
                    });
                },
                function () {
                  part_dfd.resolve();
                }
              );
            });
          })(design, part_dfd);
        }
      });
    }, 0);

    var dfd = $.Deferred();

    $.when.apply(null, part_dfds).then(function () {
      if (design.hollowing.abort) {
        _this._resolve_abort(design);
        dfd.reject();
      } else {
        _this.enableUIComponents(true);
        _this.viewer.setLocal(false);
        dfd.resolve();
      }
    });

    return dfd.promise();
  },

  deinitUI: function () {
    if (this.cursorON) {
      this.removeCursor();
    }

    for (var did in this.parts) {
      var design = this.parts[did];

      delete design.hollowing;
    }

    this.viewer.clearStatusMessage();
    this.viewer.setCSGMode(0);
    this.viewer.setLocal(false);
    this.viewer.unbind("keypress");
    this.enableUIComponents(false);
    this.releaseUIComponents();
    this.on_deinit();
  },

  initModelNode: function (design) {
    var _this = this;

    if (design.node) {
      design.hollowing.modelNode = design.node;
    } else {
      design.hollowing.modelNode = this.viewer.getNodesByName("model")[0];
    }

    design.hollowing.modelNode.setDrawMode(
      Sculpteo3DViewerSceneNode.DRAWMODE_FLAT
    );

    design.hollowing._model_load = function () {
      if (design.hollowing.modelNode.material != "global") {
        design.hollowing.modelNode.setMaterial(
          design.material
            ? design.material.encoded()["material"]
            : "white_plastic"
        );
      }
      _this.viewer.setLocal(false);

      // Add existing holes to scene as soon as the design is loaded
      // We don't want floating cylinders while loading
      if (_this.addHoles) {
        _this.addHoles = false;
        design.hollowing.holeList.forEach(function (node) {
          design.hollowing.hole_container.appendChild(node);
        });
      }
    };

    design.hollowing.modelNode.addEventListener(
      "load",
      design.hollowing._model_load
    );

    // Listen for progress to update viewer messages
    design.hollowing._model_progress = function (val) {
      if (val == 100) {
        if (_this.designValid) {
          _this.viewer.clearStatusMessage();
          _this.viewer.setLoadingComplete();
        }
      } else {
        _this.viewer.setStatusMessage(
          gettext("Loading 3D model"),
          true,
          parseFloat(val) / 100
        );
      }
    };

    design.hollowing.modelNode.addEventListener(
      "progress",
      design.hollowing._model_progress
    );

    // Listen for problems while hollowing
    design.hollowing._model_warnings = function (msg) {
      var m = JSON.parse(msg);

      if (m && m[0].id == "hollowing_design_too_small") {
        design.hollowing.error_too_small = true;
        _this.remove_part_hollowing(design, true);
        _this.fatal_error_check();
      }
    };

    design.hollowing.modelNode.addEventListener(
      "warnings",
      design.hollowing._model_warnings
    );

    // Listen on click for adding holes
    design.hollowing._model_click = function (
      x,
      y,
      rox,
      roy,
      roz,
      rdx,
      rdy,
      rdz
    ) {
      // If cursor is visible, add a new hole and enter edit hole mode
      if (_this.cursorON) {
        _this.createHoleFromCursor(design, x, y);
        _this.holeModified = true;
        _this.removeCursor();
        _this.on_add_hole(design);
      } else {
        // Delete a hole if selected
        if (_this.selectedHole != null) {
          _this.selectHole(null);
        }
      }
    };

    design.hollowing.modelNode.click(design.hollowing._model_click);
  },

  deinitModelNode: function (design) {
    if (design.hollowing.modelNode) {
      design.hollowing.modelNode.removeEventListener(
        "load",
        design.hollowing._model_load
      );
      delete design.hollowing._model_load;
      design.hollowing.modelNode.removeEventListener(
        "progress",
        design.hollowing._model_progress
      );
      delete design.hollowing._model_progress;
      design.hollowing.modelNode.removeEventListener(
        "click",
        design.hollowing._model_click
      );
      delete design.hollowing._model_click;
      design.hollowing.modelNode.removeEventListener(
        "warnings",
        design.hollowing._model_warnings
      );
      delete design.hollowing._model_warnings;
    }
  },

  initShellDesign: function () {
    var dfd = $.Deferred();

    var _this = this;

    _this.shell_node = _this.viewer.createNode("shell_node");
    _this.shell_node.setDrawMode(Sculpteo3DViewerSceneNode.DRAWMODE_FLAT);

    _this.shell_design.fetch_operation(true, false).then(function () {
      design.hollowing.abort_wait--;

      if (design.hollowing.abort) {
        dfd.reject();
        _this._resolve_abort(design);

        return;
      }

      // Get the script operations and discard components not created by hollowing
      var script = _this.shell_design.get_operation("ScriptOperation");
      var cone_array = [2];

      script
        .modify({
          cones: "[" + cone_array.toString() + "]",
        })
        .then(function () {
          design.hollowing.abort_wait--;

          if (design.hollowing.abort) {
            dfd.reject();
            _this._resolve_abort(design);

            return;
          }

          _this.shell_design
            .load_in_viewer(_this.viewer, _this.shell_node.id)
            .then(function () {
              _this.orig_design.hollowing.hole_container.appendChild(
                _this.shell_node
              );
              dfd.resolve();
            });
        });
    });

    return dfd.promise();
  },

  initOperations: function (design) {
    var _this = this;

    // Fetch original design operations
    design.hollowing.orig_op_hollow = design.get_operation(
      "HollowDesignOperation"
    );

    var dfd = $.Deferred();

    // If operations exist, initialize the interface with existing data
    if (design.hollowing.orig_op_hollow) {
      design.hollowing.orig_op_script = design.get_operation_by_seq(
        design.hollowing.orig_op_hollow.seq + 1
      );

      // Load the clone operations data
      design.hollowing.op_hollow = design.hollowing.design.get_operation(
        "HollowDesignOperation"
      );

      if (design.hollowing.op_hollow) {
        design.hollowing.op_script =
          design.hollowing.design.get_operation_by_seq(
            design.hollowing.op_hollow.seq + 1
          );
      }

      // Fetch values from operations
      design.hollowing.gridStep = Math.round(
        design.hollowing.designDiag / design.hollowing.op_hollow.data.step
      );
      design.hollowing.wallThickness =
        design.hollowing.op_hollow.data.offset *
        design.hollowing.userScaleFactor;

      // Update the sliders values without trigering a loop
      this.allow_update_sliders = false;
      this.updateWallSlidersVal();
      this.allow_update_sliders = true;

      // Check if there are existing holes
      // If not, fail the operation
      if (design.hollowing.op_script.data.cones.length > 0) {
        var cones = eval(design.hollowing.op_script.data.cones);

        if (cones.length > 0) {
          // Recreate holes from saved data
          var add = cones.shift();

          design.hollowing.holeCount = this.holesFromCones(
            design,
            cones,
            false
          );
          this.holeCount = design.hollowing.holeCount;
          this.switchToModelSave(false);
          design.hollowing.orig_op_script = null;
          design.hollowing.orig_op_hollow = null;

          // Update script operation to disable holes so that we get
          // the design without holes
          this.updateScriptOperation(design, false, true).then(function () {
            _this.request_warnings().then(function () {
              // Load the design
              // (holes will be added to the scene when loading is done)
              _this.addHoles = true;
              _this.designValid = true;
              design.hollowing.orig_op_hollow = design.get_operation(
                "HollowDesignOperation"
              );

              if (design.hollowing.orig_op_hollow) {
                design.hollowing.orig_op_script = design.get_operation_by_seq(
                  design.hollowing.orig_op_hollow.seq + 1
                );
              }

              design.hollowing.op_script = null; // No need to update script op for the copy
              _this.viewer.setLocal(true);
              design.hollowing.design
                .load_in_viewer(_this.viewer, design.hollowing.modelNode.id)
                .then(function () {
                  dfd.resolve(true);
                });
            });
          });
        } else {
          dfd.resolve(false);
        }
      } else {
        dfd.resolve(false);
      }
    } else {
      // Create the operations in the clone, don't touch the original for now
      this.updateHollowArgs(design);
      this.updateScriptArgs(design, false);

      // Create hollowing operation
      design.hollowing.abort_wait++;
      design.hollowing.design.add_operation(this.args_hollow).then(
        function () {
          design.hollowing.abort_wait--;
          design.hollowing.op_hollow = design.hollowing.design.get_operation(
            "HollowDesignOperation"
          );

          if (design.hollowing.abort) {
            dfd.reject();
            _this._resolve_abort(design);

            return;
          }

          // Create script operation
          design.hollowing.abort_wait++;
          design.hollowing.design.add_operation(_this.args_script).then(
            function () {
              design.hollowing.abort_wait--;

              if (design.hollowing.abort) {
                dfd.reject();
                _this._resolve_abort(design);

                return;
              }

              _this.designValid = true;
              _this.viewer.setLocal(true);

              // Everything is ok, load the clone
              design.hollowing.design
                .load_in_viewer(_this.viewer, design.hollowing.modelNode.id)
                .then(function () {
                  dfd.resolve(true);
                });
            },
            function () {
              dfd.reject();

              if (design.hollowing.abort) {
                _this._resolve_abort(design);

                return;
              }
            }
          );
        },
        function () {
          dfd.reject();

          if (design.hollowing && design.hollowing.abort) {
            _this._resolve_abort(design);

            return;
          }
        }
      );
    }

    return dfd.promise();
  },

  init_hole_model: function () {
    var _this = this;
    var dfd = $.Deferred();

    _this.hole_design = new Design({ empty_design: true });

    // Start design editing
    _this.abort_wait++;
    setTimeout(function () {
      _this.hole_design.start_editing(false).then(
        function () {
          _this.abort_wait--;

          if (_this.abort) {
            dfd.reject();
            _this._resolve_abort();

            return;
          }

          // Add a create cone script operation to generate the hole cylinder
          var args = {
            id: _this.args_script["id"],
            language: "template/javascript",
            script: '{% include "gallery/create_unit_cone.js" %}',
            locked_fields: "script",
            force_locked_fields: "",
            need_html: 0,
          };

          _this.abort_wait++;
          setTimeout(function () {
            _this.hole_design.add_operation(args).then(
              function () {
                _this.abort_wait--;

                if (_this.abort) {
                  dfd.reject();
                  _this._resolve_abort();

                  return;
                }

                // Everything is ok, create the node and load the design
                _this.hole_node = _this.viewer.createNode("hole_node");
                _this.hole_node.setDrawMode(
                  Sculpteo3DViewerSceneNode.DRAWMODE_FLAT
                );
                _this.abort_wait++;
                setTimeout(function () {
                  _this.hole_design
                    .load_in_viewer(_this.viewer, _this.hole_node.id)
                    .then(function () {
                      setTimeout(function () {
                        _this.abort_wait--;

                        if (_this.abort) {
                          dfd.reject();
                          _this._resolve_abort();

                          return;
                        }

                        dfd.resolve();
                      }, 0);
                    });
                }, 0);
              },
              function () {
                dfd.reject();

                if (_this.abort) {
                  _this._resolve_abort();

                  return;
                }
              }
            );
          }, 0);
        },
        function () {
          dfd.reject();

          if (_this.abort) {
            _this._resolve_abort();

            return;
          }
        }
      );
    }, 0);

    return dfd.promise();
  },

  initUIComponents: function (design, options) {
    var _this = this;

    if (options["thickness_slider"]) {
      $(options["thickness_slider"]).slider({
        disabled: true,
        min: -_this.minWallThickness,
        max: -_this.maxWallThickness,
        step: _this.stepWallThickness,
        value: -design.hollowing.wallThickness,
        create: function (event, ui) {
          $("label .slider_val", $(this).parent()).html(
            _this.formatUnitValue($(this).slider("value"))
          );
        },

        change: function (event, ui) {
          $("label .slider_val", $(this).parent()).html(
            _this.formatUnitValue(ui.value)
          );

          if (!_this.allow_update_sliders) {
            return;
          }

          _this.enableUIComponents(false);
          _this
            .updateHollowOperation(design, { offset: ui.value })
            .then(function () {
              if (design.hollowing.design) {
                design.hollowing.design
                  .load_in_viewer(_this.viewer, design.hollowing.modelNode.id)
                  .then(function () {
                    _this.on_wall_change();
                    _this.enableUIComponents(true);
                  });
              }
            });
        },

        slide: function (event, ui) {
          $("label .slider_val", $(this).parent()).html(
            _this.formatUnitValue(ui.value)
          );
        },
      });
      $(
        "label .slider_val",
        $(options["thickness_slider"] + ".ui-slider").parent()
      ).html(
        _this.formatUnitValue(
          $(options["thickness_slider"] + ".ui-slider").slider("value")
        )
      );
    }

    if (options["thickness_input"]) {
      var el = $(options["thickness_input"]);
      el.attr("min", _this.getValueInPartUnits(-_this.minWallThickness));
      el.attr("max", _this.getValueInPartUnits(-_this.maxWallThickness));
      el.attr("step", _this.getValueInPartUnits(-_this.stepWallThickness));
      el.val(_this.getValueInPartUnits(-design.hollowing.wallThickness));
      el.change(function () {
        if (!_this.allow_update_sliders) {
          return;
        }

        _this.enableUIComponents(false);
        _this
          .updateHollowOperation(design, {
            offset: _this.getValueInBackendUnit(this.value),
          })
          .then(function () {
            if (design.hollowing.design) {
              design.hollowing.design
                .load_in_viewer(_this.viewer, design.hollowing.modelNode.id)
                .then(function () {
                  _this.on_wall_change();
                  _this.enableUIComponents(true);
                });
            }
          });
      });
    }

    if (options["step_slider"]) {
      $(options["step_slider"]).slider({
        disabled: true,
        min: _this.minGridStep,
        max: _this.maxGridStep,
        step: _this.stepGridStep,
        value: design.hollowing.gridStep,
        create: function (event, ui) {
          $("label .slider_val", $(this).parent()).html(
            _this.formatIntValue($(this).slider("value"))
          );
        },

        change: function (event, ui) {
          $("label .slider_val", $(this).parent()).html(
            _this.formatIntValue(ui.value)
          );

          if (!_this.allow_update_sliders) {
            return;
          }

          _this
            .updateHollowOperation(design, { step: ui.value })
            .then(function () {
              if (design.hollowing.design) {
                design.hollowing.design
                  .load_in_viewer(_this.viewer, design.hollowing.modelNode.id)
                  .then(function () {
                    _this.on_wall_change();
                    _this.enableUIComponents(true);
                  });
              }
            });
        },

        slide: function (event, ui) {
          $("label .slider_val", $(this).parent()).html(
            _this.formatIntValue(ui.value)
          );
        },
      });
      $(
        "label .slider_val",
        $(options["step_slider"] + ".ui-slider").parent()
      ).html(
        _this.formatIntValue(
          $(options["step_slider"] + ".ui-slider").slider("value")
        )
      );
    }

    if (options["hole_width_slider"]) {
      $(options["hole_width_slider"]).slider({
        disabled: true,
        min: _this.minHoleWidth,
        max: _this.maxHoleWidth,
        step: _this.stepHoleWidth,
        value: design.hollowing.holeWidth,
        create: function (event, ui) {
          $("label .slider_val", $(this).parent()).html(
            _this.formatUnitValue($(this).slider("value"))
          );
        },

        change: function (event, ui) {
          $("label .slider_val", $(this).parent()).html(
            _this.formatUnitValue(ui.value)
          );

          if (!_this.allow_update_sliders) {
            return;
          }

          design.hollowing.holeWidth = ui.value;
          _this.updateHoleParams();
        },

        slide: function (event, ui) {
          $("label .slider_val", $(this).parent()).html(
            _this.formatUnitValue(ui.value)
          );
        },
      });
      $(
        "label .slider_val",
        $(options["hole_width_slider"] + ".ui-slider").parent()
      ).html(
        _this.formatUnitValue(
          $(options["hole_width_slider"] + ".ui-slider").slider("value")
        )
      );
    }

    if (options["hole_depth_slider"]) {
      $(options["hole_depth_slider"]).slider({
        disabled: true,
        min: _this.minHoleDepth,
        max: _this.maxHoleDepth,
        step: _this.stepHoleDepth,
        value: design.hollowing.holeDepth,
        create: function (event, ui) {
          $("label .slider_val", $(this).parent()).html(
            _this.formatUnitValue($(this).slider("value"))
          );
        },

        change: function (event, ui) {
          $("label .slider_val", $(this).parent()).html(
            _this.formatUnitValue(ui.value)
          );

          if (!_this.allow_update_sliders) {
            return;
          }

          design.hollowing.holeDepth = ui.value;
          _this.updateHoleParams();
        },

        slide: function (event, ui) {
          $("label .slider_val", $(this).parent()).html(
            _this.formatUnitValue(ui.value)
          );
        },
      });
      $(
        "label .slider_val",
        $(options["hole_depth_slider"] + ".ui-slider").parent()
      ).html(
        _this.formatUnitValue(
          $(options["hole_depth_slider"] + ".ui-slider").slider("value")
        )
      );
    }

    if (options["hole_height_slider"]) {
      $(options["hole_height_slider"]).slider({
        disabled: true,
        min: _this.minHoleHeight,
        max: _this.maxHoleHeight,
        step: _this.stepHoleHeight,
        value: design.hollowing.holeHeight,
        create: function (event, ui) {
          $("label .slider_val", $(this).parent()).html(
            _this.formatUnitValue($(this).slider("value"))
          );
        },

        change: function (event, ui) {
          $("label .slider_val", $(this).parent()).html(
            _this.formatUnitValue(ui.value)
          );

          if (!_this.allow_update_sliders) {
            return;
          }

          design.hollowing.holeHeight = ui.value;
          _this.updateHoleParams();
        },

        slide: function (event, ui) {
          $("label .slider_val", $(this).parent()).html(
            _this.formatUnitValue(ui.value)
          );
        },
      });
      $(
        "label .slider_val",
        $(options["hole_height_slider"] + ".ui-slider").parent()
      ).html(
        _this.formatUnitValue(
          $(options["hole_height_slider"] + ".ui-slider").slider("value")
        )
      );
    }

    this.enableUIComponents(false);

    if (options["add_hole_button"]) {
      options["add_hole_button"].bind("click.hollowing", function () {
        if (this.disabled) {
          return;
        }

        _this.start_add_hole();
      });
    }

    if (options["add_second_hole_button"]) {
      options["add_second_hole_button"].bind("click.hollowing", function () {
        if (this.disabled) {
          return;
        }

        _this.start_add_hole();
      });
    }

    if (options["done_hole_button"]) {
      options["done_hole_button"].bind("click.hollowing", function () {
        if (this.disabled) {
          return;
        }

        _this.finish_add_hole();
      });
    }

    if (options["delete_selected_hole_button"]) {
      options["delete_selected_hole_button"].bind(
        "click.hollowing",
        function () {
          if ($(this).hasClass("disabled")) {
            return;
          }

          _this.delete_selected_hole();
        }
      );
    }

    if (options["delete_last_hole_button"]) {
      options["delete_last_hole_button"].bind("click.hollowing", function () {
        if (this.disabled) {
          return;
        }

        _this.delete_last_hole();
      });
    }

    if (options["create_holes_button"]) {
      options["create_holes_button"].bind("click.hollowing", function () {
        if ($(this).hasClass("disabled")) {
          return;
        }

        _this.create_holes();
      });
    }

    if (options["start_editing_button"]) {
      options["start_editing_button"].bind("click.hollowing", function () {
        if ($(this).hasClass("disabled")) {
          return;
        }

        _this.start_hole_editing();
      });
    }

    if (options["reset_button"]) {
      options["reset_button"].bind("click.hollowing", function () {
        if ($(this).hasClass("disabled")) {
          return;
        }

        _this.remove_all_holes();
      });
    }
  },

  releaseUIComponents: function () {
    var options = this.options;

    if (options["thickness_slider"]) {
      $(options["thickness_slider"]).slider({
        create: null,
        change: null,
        slide: null,
      });
    }

    if (options["step_slider"]) {
      $(options["step_slider"]).slider({
        create: null,
        change: null,
        slide: null,
      });
    }

    if (options["hole_width_slider"]) {
      $(options["hole_width_slider"]).slider({
        create: null,
        change: null,
        slide: null,
      });
    }

    if (options["hole_depth_slider"]) {
      $(options["hole_depth_slider"]).slider({
        create: null,
        change: null,
        slide: null,
      });
    }

    if (options["hole_height_slider"]) {
      $(options["hole_height_slider"]).slider({
        create: null,
        change: null,
        slide: null,
      });
    }

    if (options["add_hole_button"]) {
      options["add_hole_button"].unbind("click.hollowing");
    }

    if (options["add_second_hole_button"]) {
      options["add_second_hole_button"].unbind("click.hollowing");
    }

    if (options["done_hole_button"]) {
      options["done_hole_button"].unbind("click.hollowing");
    }

    if (options["delete_selected_hole_button"]) {
      options["delete_selected_hole_button"].unbind("click.hollowing");
    }

    if (options["delete_last_hole_button"]) {
      options["delete_last_hole_button"].unbind("click.hollowing");
    }

    if (options["create_holes_button"]) {
      options["create_holes_button"].unbind("click.hollowing");
    }

    if (options["start_editing_button"]) {
      options["start_editing_button"].unbind("click.hollowing");
    }

    if (options["reset_button"]) {
      options["reset_button"].unbind("click.hollowing");
    }
  },

  /****************************
   * Actions
   ***************************/

  /**
   * Request abort of operations in progress.
   * @returns Deferred
   */
  abort_ops: function () {
    var _this = this;
    var dfds = [];

    for (var did in this.parts) {
      var design = this.parts[did];

      design.hollowing.dfd_abort = $.Deferred();
      design.hollowing.abort = true;

      if (!design.hollowing.abort_wait) {
        design.hollowing.dfd_abort.resolve();
      }

      dfds.push(design.hollowing.dfd_abort);
    }

    this.dfd_abort = $.Deferred();
    this.abort = true;
    $.when.apply(null, dfds).then(function () {
      if (!_this.abort_wait) {
        _this.abort = false;
        _this.dfd_abort.resolve();
      }
    });

    return this.dfd_abort.promise();
  },

  /**
   * Resolves an abort request.
   * @private
   */
  _resolve_abort: function (design) {
    if (design) {
      design.hollowing.abort = false;
      design.hollowing.dfd_abort.resolve();
    } else {
      this.abort = false;
      this.dfd_abort.resolve();
    }
  },

  /**
   * Initializes hole adding.
   * Disable CSG and remote rendering.
   * Initialize cursor
   */
  start_add_hole: function () {
    this.switchToHoleEdit(true);
    this.initCursor();
    this.viewer.setCSGMode(0);
    this.viewer.setLocal(true);
  },

  /**
   * Creates the final hole and exits the edit hole mode.
   */
  finish_add_hole: function (design) {
    var _this = this;

    // Check if some hole parameters were modified
    if (this.holeModified) {
      this.enableEditingHolesInteraction(false);

      function onDone() {
        _this.request_warnings().then(function () {
          _this.switchToHoleEdit(false);
          _this.selectHole(null);

          if (_this.cursorON) {
            _this.removeCursor();
          }

          _this.enableEditingHolesInteraction(true);
          _this.viewer.setLocal(false);
          _this.on_add_hole_done();
        });
      }

      // If this was the first hole, create the operations
      // in the original design so that we get a price update,
      // otherwise, just update the script operation
      if (design.hollowing.holeCount == 1) {
        this.create_orig_operations(design).then(onDone);
      } else {
        this.updateScriptOperation(design, false, true).then(onDone);
      }
    } else {
      // Just exit the edit hole mode
      this.switchToHoleEdit(false);
      this.selectHole(null);

      if (this.cursorON) {
        this.removeCursor();
      }

      this.viewer.setLocal(false);
    }

    this.viewer.setCSGMode(1);
  },

  /**
   * Deletes the selected hole.
   */
  delete_selected_hole: function () {
    var node = this.selectedHole;

    if (this.cursorON) {
      this.removeCursor();
    }

    if (node != null) {
      // Unselect the hole, remove it from the list and the scene
      this.viewer.setLocal(true);
      this.selectHole(null, true);
      this.removeHoleFromlist(node);
      node.detach();
      this.enableEditingHolesInteraction(false);
      var _this = this;

      _this.on_delete_hole_start();

      // Update the script operation
      this.updateScriptOperation(node.design, false, true).then(function () {
        _this.request_warnings().then(function () {
          // If there are no more holes, remove the operations from
          // the original design to get back to the original price
          if (node.design.hollowing.holeCount == 0) {
            _this.remove_orig_operations(node.design).then(function () {
              _this.on_delete_hole();
              _this.switchToHoleEdit(false);
              _this.enableEditingHolesInteraction(true);
              _this.viewer.setLocal(false);
            });
          } else {
            _this.on_delete_hole();
            _this.switchToHoleEdit(false);
            _this.enableEditingHolesInteraction(true);
            _this.viewer.setLocal(false);
          }
        });
      });
    }

    this.viewer.setCSGMode(1);
  },

  /**
   * Delets the last added hole.
   */
  delete_last_hole: function () {
    if (this.hole_order_list.length == 0) {
      return;
    }

    this.holeModified = false;
    var hole = this.hole_order_list[this.hole_order_list.length - 1];

    this.selectHole(hole, true);
    this.holeModified = false;
    this.delete_selected_hole();
  },

  /**
   * Creates and loads the final design with drilled holes.
   * @returns {*}
   */
  create_holes: function (allow_no_holes) {
    var _this = this;

    if (_this.dfd_create_holes) {
      return _this.dfd_create_holes.promise();
    }

    _this.dfd_create_holes = $.Deferred();

    // If holes were allready created, exit
    if (_this.holesCreated) {
      _this.dfd_create_holes.resolve();

      return _this.dfd_create_holes.promise();
    }

    _this.holesCreated = true;

    _this.viewer.setStatusMessage(gettext("Loading 3D model"), false, 0);

    _this.viewer.setLocal(true);

    var dfds = [];

    function loadOrigModel(design, dfd) {
      _this.switchToModelSave(true);

      if (_this.cursorON) {
        _this.removeCursor();
      }

      _this.deinitModelNode(design);
      dfd.resolve();
    }

    // If there are holes, update the script operations
    for (var did in _this.parts) {
      var design = _this.parts[did];
      if (!design) continue;

      var dfd = $.Deferred();
      dfds.push(dfd);
      (function (design, dfd) {
        if (allow_no_holes || design.hollowing.holeList.length > 0) {
          var dfd_orig = true;
          if (allow_no_holes && !design.hollowing.orig_op_script) {
            dfd_orig = _this.create_orig_operations(design);
          }
          $.when(dfd_orig).then(function () {
            _this.updateScriptOperation(design, true, false).then(function () {
              // Remove the holes from the scene and load the original design
              design.hollowing.holeList.forEach(function (node) {
                node.destruct();
              });

              design.hollowing.hole_container.destruct();
              loadOrigModel(design, dfd);
            });
          });
        } else {
          design.hollowing.hole_container.destruct();
          loadOrigModel(design, dfd);
        }
      })(design, dfd);
    }

    var dfds2 = [];

    for (var did in _this.parts) {
      dfds2[did] = $.Deferred();
    }

    $.when.apply(null, dfds).then(function () {
      // _this.viewer.clearSceneComplete();
      for (var did in _this.parts) {
        var design = _this.parts[did];

        // Load the original design
        (function (design, did) {
          var name = design.node ? design.node.id : null;

          design.load_in_viewer(_this.viewer, name).then(function () {
            dfds2[did].resolve();
          });
        })(design, did);
      }
    });

    $.when.apply(null, dfds2).then(function () {
      _this.viewer.setLocal(false);
      _this.dfd_create_holes.resolve();
      _this.dfd_create_holes = null;
    });

    if (_this.dfd_create_holes) {
      return _this.dfd_create_holes.promise();
    } else {
      var dfd = $.Deferred();

      dfd.resolve();

      return dfd.promise();
    }
  },

  /**
   * Goes back from the design with created holes to the hollowing edit mode.
   */
  start_hole_editing: function () {
    var _this = this;

    if (!_this.holesCreated) {
      return;
    }

    _this.holesCreated = false;
    this.viewer.setStatusMessage(gettext("Loading 3D model"), false, 0);

    var dfds = [];

    for (var did in this.parts) {
      var design = this.parts[did];
      var des_dfd = $.Deferred();

      dfds.push(des_dfd);

      // Disable the creation of holes
      (function (design, des_dfd) {
        this.updateScriptOperation(design, false, false).then(function () {
          // Load the clone
          _this.viewer.loadModel(
            design.hollowing.design.model_url(),
            design.hollowing.modelNode.id
          );
          des_dfd.resolve();
        });
      })(design, des_dfd);
    }

    $.when.apply(null, dfds).then(function () {
      _this.addHoles = true;
      _this.switchToModelSave(false);
    });
  },

  /**
   * Removes all holes. Also removes the operations from the original design.
   * @returns {*}
   */
  remove_all_holes: function () {
    var _this = this;

    this.viewer.setLocal(true);

    var dfds = [];

    for (var did in this.parts) {
      var design = this.parts[did];
      var des_dfd = $.Deferred();

      dfds.push(des_dfd);
      this.clearHoleList(design);
      (function (design, des_dfd) {
        _this.remove_orig_operations(design).then(function () {
          des_dfd.resolve();
        });
      })(design, des_dfd);
    }

    var dfd = $.Deferred();

    $.when.apply(null, dfds).then(function () {
      _this.viewer.setLocal(false);
      _this.on_delete_all_holes();
      dfd.resolve();
    });

    return dfd.promise();
  },

  /**
   * Removes holowing for one part
   */

  remove_part_hollowing: function (design, reload) {
    var _this = this;
    var des_dfd = $.Deferred();
    var dfd_op = true;

    _this.clearHoleList(design);

    // Remove operations if they exist on the original design
    if (design.hollowing.orig_op_script) {
      dfd_op = design.hollowing.orig_op_script.remove();
    }

    $.when(dfd_op).then(function () {
      dfd_op = true;

      if (design.hollowing.orig_op_hollow) {
        dfd_op = design.hollowing.orig_op_hollow.remove();
      }

      $.when(dfd_op).then(function () {
        _this.deinitModelNode(design);

        if (reload) {
          var name = design.node ? design.node.id : null;

          design.load_in_viewer(_this.viewer, name).then(function () {
            des_dfd.resolve();
          });
        } else {
          des_dfd.resolve();
        }
      });
    });

    return des_dfd;
  },

  /**
   * Removes hollowing completely and exits hollowing edit mode.
   * @returns {*}
   */
  remove_hollowing_and_deinit: function () {
    var _this = this;

    this.viewer.setLocal(true);

    if (this.cursorON) {
      this.removeCursor();
    }

    var dfds = [];

    // Don't reload designs so that it can be parallelized later
    for (var did = 0; did < this.parts.length; ++did) {
      dfds.push(_this.remove_part_hollowing(_this.parts[did]), false);
    }

    var dfds2 = [];

    for (var did in _this.parts) {
      dfds2[did] = $.Deferred();
    }

    $.when.apply(null, dfds).then(function () {
      // _this.viewer.clearSceneComplete();
      for (var did in _this.parts) {
        var design = _this.parts[did];

        (function (design, did) {
          var name = design.node ? design.node.id : null;

          if (design.hollowing.hole_container) {
            design.hollowing.hole_container.destruct();
          }

          design.load_in_viewer(_this.viewer, name).then(function () {
            dfds2[did].resolve();
          });
        })(design, did);
      }
    });

    var dfd = $.Deferred();

    $.when.apply(null, dfds2).then(function () {
      _this.deinitUI();
      _this.viewer.setLocal(false);
      _this.on_delete_all_holes();
      dfd.resolve();
    });

    return dfd.promise();
  },

  /**
   * Get warnings from server produced by hollowing the original design
   */
  request_warnings: function () {
    var _this = this;

    var dfds = [];

    _this.design_warnings = [];
    _this.have_one_hole = 0;
    _this.not_hollowed = 0;

    for (var did in _this.parts) {
      var part_dfd = $.Deferred();

      dfds.push(part_dfd);
      var design = _this.parts[did];

      (function (design, part_dfd) {
        design.get_warnings().then(function (msg) {
          if (msg) {
            for (var i = 0; i < msg.length; ++i) {
              if (msg[i].id == "hollowing_one_hole") {
                _this.have_one_hole = msg[i].params[0];
              } else if (msg[i].id == "hollowing_not_hollowed") {
                _this.not_hollowed = msg[i].params[0];
              }

              var add = true;

              for (var j = 0; j < _this.design_warnings.length; ++j) {
                if (_this.design_warnings[j].id == msg[i].id) {
                  add = false;
                }
              }

              if (add) {
                _this.design_warnings.push(msg[i]);
              }
            }
          }

          part_dfd.resolve();
        });
      })(design, part_dfd);
    }

    var dfd = $.Deferred();

    $.when.apply(null, dfds).then(function () {
      dfd.resolve();
    });

    return dfd.promise();
  },

  /****************************
   * Events
   ***************************/

  /**
   * Called when wall thickness changes
   */
  on_wall_change: function () {},

  /**
   * Called when a new hole is added
   */
  on_add_hole: function () {},

  /**
   * Called when a newly added hole is saved
   */
  on_add_hole_done: function () {},

  /**
   * Called when a hole is updated
   */
  on_update_hole: function () {},

  /**
   * Called before a hole is deleted
   */
  on_delete_hole_start: function () {},

  /**
   * Called when a hole is deleted
   */
  on_delete_hole: function () {},

  /**
   * Called when all holes are removed by calling remove_all_holes
   */
  on_delete_all_holes: function () {},

  /**
   * Called when exiting hollowing edit mode
   */
  on_deinit: function () {},

  /**
   * Called when modification is done on the hollowing on update scale
   * @param is_hollowing True if hollowing will be activated, False otherwise
   */
  onModification: function (is_hollowing, msg) {},

  /**
   * Called when there was a fatal error while doing hollowing operations
   * @param msg Error message id
   */
  on_fatal_error: function (msg) {},

  fatal_error_check: function () {
    var fatal = true;

    for (var did in this.parts) {
      var design = this.parts[did];

      if (!design.hollowing.error_too_small) {
        fatal = false;
        break;
      }
    }

    if (fatal) {
      this.on_fatal_error({ id: "hollowing_design_too_small" });
    }
  },

  /****************************
   * Operation updates
   ***************************/

  updateHollowArgs: function (design) {
    this.args_hollow["offset"] =
      design.hollowing.wallThickness / design.hollowing.userScaleFactor;
    this.args_hollow["step"] =
      design.hollowing.designDiag / design.hollowing.gridStep;
    if (design.hollowing_sequence !== undefined) {
      this.args_hollow["sequence"] = design.hollowing_sequence;
    }
  },

  updateScriptArgs: function (design, createHoles) {
    var cone_array = [];

    if (createHoles) {
      cone_array.push(1);
    } else {
      cone_array.push(0);
    }

    cone_array.push(design.hollowing.wallThickness);
    cone_array.push(design.hollowing.scaleFactor);
    design.hollowing.holeList.forEach(function (node) {
      cone_array.push(node.hole_width);
      cone_array.push(node.hole_depth);
      cone_array.push(node.hole_height);
      cone_array.push(node.transform.toArray());
    });

    this.args_script["cones.value"] = "[" + cone_array.toString() + "]";

    if (design.hollowing_sequence !== undefined) {
      this.args_script["sequence"] = design.hollowing_sequence + 1;
    }
  },

  updateHollowOperation: function (design, options) {
    var dfd = $.Deferred();

    if (!design.hollowing.op_hollow && !design.hollowing.orig_op_hollow) {
      dfd.resolve();

      return dfd.promise();
    }

    if (typeof options["offset"] != "undefined") {
      options["offset"] = -options["offset"];
      design.hollowing.wallThickness = options["offset"];
      options["offset"] /= design.hollowing.userScaleFactor;
    }

    if (typeof options["step"] != "undefined") {
      design.hollowing.gridStep = options["step"];
      options["step"] = design.hollowing.designDiag / options["step"];
    }

    var _this = this;

    if (design.hollowing.op_hollow) {
      var dfd1 = design.hollowing.op_hollow.modify(options);
    }

    if (design.hollowing.orig_op_hollow) {
      var dfd2 = design.hollowing.orig_op_hollow.modify(options);
    }

    design.hollowing.abort_wait++;
    $.when(dfd1, dfd2).then(
      function () {
        design.hollowing.abort_wait--;

        if (design.hollowing.abort) {
          dfd.reject();
          _this._resolve_abort(design);

          return;
        }

        _this.updateScriptOperation(design, false, false).then(function () {
          if (design.hollowing.op_hollow) {
            _this.updateHolesWallThicknes();
          }

          dfd.resolve();
        });
      },
      function () {
        dfd.reject();

        if (design.hollowing.abort) {
          _this._resolve_abort(design);

          return;
        }
      }
    );

    return dfd.promise();
  },

  updateScriptOperation: function (design, createHoles, showMessage) {
    var dfd = $.Deferred();

    if (!design.hollowing.op_script && !design.hollowing.orig_op_script) {
      dfd.resolve();

      return dfd.promise();
    }

    if (showMessage) {
      this.viewer.setStatusMessage(
        gettext("Saving hole information ..."),
        false,
        0
      );
    }

    var cone_array = [];

    if (createHoles) {
      cone_array.push(1);
    } else {
      cone_array.push(0);
    }

    cone_array.push(design.hollowing.wallThickness);
    cone_array.push(design.hollowing.scaleFactor);
    design.hollowing.holeList.forEach(function (node) {
      cone_array.push(node.hole_width);
      cone_array.push(node.hole_depth);
      cone_array.push(node.hole_height);
      cone_array.push(node.transform.toArray());
    });

    var _this = this;

    if (design.hollowing.op_script) {
      var dfd1 = design.hollowing.op_script.modify({
        cones: "[" + cone_array.toString() + "]",
      });
    }

    if (design.hollowing.orig_op_script) {
      cone_array[0] = 1;
      var dfd2 = design.hollowing.orig_op_script.modify({
        cones: "[" + cone_array.toString() + "]",
      });
    }

    design.hollowing.abort_wait++;
    $.when(dfd1, dfd2).then(
      function () {
        design.hollowing.abort_wait--;

        if (design.hollowing.abort) {
          dfd.reject();
          _this._resolve_abort(design);

          return;
        }

        _this.holeModified = false;

        if (showMessage) {
          _this.viewer.clearStatusMessage();
        }

        dfd.resolve();
      },
      function () {
        dfd.reject();

        if (design.hollowing.abort) {
          _this._resolve_abort(design);

          return;
        }
      }
    );

    return dfd.promise();
  },

  create_orig_operations: function (design) {
    if (design.hollowing.orig_op_hollow) {
      return;
    }

    var _this = this;
    var dfd = $.Deferred();

    this.updateHollowArgs(design);
    this.updateScriptArgs(design, true);
    design.hollowing.abort_wait++;
    design.add_operation(this.args_hollow).then(
      function () {
        design.hollowing.abort_wait--;
        design.hollowing.orig_op_hollow = design.get_operation(
          "HollowDesignOperation"
        );

        if (design.hollowing.abort) {
          dfd.reject();
          _this._resolve_abort(design);

          return;
        }

        design.hollowing.abort_wait++;
        design.add_operation(_this.args_script).then(
          function () {
            design.hollowing.abort_wait--;
            design.hollowing.orig_op_script = design.get_operation_by_seq(
              design.hollowing.orig_op_hollow.seq + 1
            );

            if (design.hollowing.abort) {
              dfd.reject();
              _this._resolve_abort(design);

              return;
            }

            _this.holeModified = false;
            dfd.resolve(true);
          },
          function () {
            dfd.reject();

            if (design.hollowing.abort) {
              _this._resolve_abort(design);

              return;
            }
          }
        );
      },
      function () {
        dfd.reject();

        if (design.hollowing.abort) {
          _this._resolve_abort(design);

          return;
        }
      }
    );

    return dfd.promise();
  },

  remove_orig_operations: function (design) {
    var _this = this;
    var dfd = $.Deferred();

    if (!design.hollowing.orig_op_hollow) {
      dfd.resolve();

      return dfd.promise();
    }

    design.hollowing.abort_wait++;
    design.hollowing.orig_op_script.remove().then(
      function () {
        design.hollowing.abort_wait--;
        design.hollowing.orig_op_script = null;

        if (design.hollowing.abort) {
          dfd.reject();
          _this._resolve_abort(design);

          return;
        }

        design.hollowing.abort_wait++;
        design.hollowing.orig_op_hollow.remove().then(
          function () {
            design.hollowing.abort_wait--;
            design.hollowing.orig_op_hollow = null;

            if (design.hollowing.abort) {
              dfd.reject();
              _this._resolve_abort(design);

              return;
            }

            dfd.resolve();
          },
          function () {
            dfd.reject();

            if (design.hollowing.abort) {
              _this._resolve_abort(design);

              return;
            }
          }
        );
      },
      function () {
        dfd.reject();

        if (design.hollowing.abort) {
          _this._resolve_abort(design);

          return;
        }
      }
    );

    return dfd.promise();
  },

  /****************************
   * Hole managing
   ***************************/

  holesFromCones: function (design, cones, addToScene) {
    var _this = this;

    design.hollowing.wallThickness = cones.shift();
    design.hollowing.scaleFactor = cones.shift();

    var offset = 19;
    var ncones = cones.length / offset;

    for (var i = 0; i < ncones; ++i) {
      var width = cones[offset * i + 0] * design.hollowing.scaleFactor;
      var depth = cones[offset * i + 1] * design.hollowing.scaleFactor;
      var height = cones[offset * i + 2] * design.hollowing.scaleFactor;
      var trans = new Sculpteo3DViewerCommonTransform3D(
        cones.slice(offset * i + 3, offset * i + 19)
      );

      var node = this.createHoleWithTransform(
        width,
        depth,
        height,
        design.hollowing.wallThickness,
        design.hollowing.scaleFactor,
        trans
      );

      node.design = design;
      node.click(function (x, y) {
        if (!_this.cursorON) {
          _this.selectHole(node);
          _this.switchToHoleEdit(_this.selectedHole != null);
        }
      });

      this.addHoleToList(node);

      if (addToScene) {
        design.hollowing.hole_container.appendChild(node);
      }
    }

    return ncones;
  },

  getHoleTransform: function (width, depth, height, wall, scale) {
    var trans = new Sculpteo3DViewerCommonTransform3D();

    trans = trans
      .scale(width / scale, width / scale, (depth + height - wall) / scale)
      .translate(0, 0, (wall - depth) / scale);

    return trans;
  },

  createHoleCylinder: function (width, depth, height, wall, scale) {
    var trans = this.getHoleTransform(width, depth, height, wall, scale);
    var node = this.viewer.createNode(
      this.hole_node.id,
      trans,
      this.hole_material
    );

    return node;
  },

  createHoleWithTransform: function (width, depth, height, wall, scale, trans) {
    this.cylinderNumber++;

    var childnode = this.createHoleCylinder(width, depth, height, wall, scale);

    var node = this.viewer.createNode("cyl_" + this.cylinderNumber, trans);

    node.hole_child = childnode;
    node.appendChild(childnode);

    node.hole_width = width / scale;
    node.hole_depth = depth / scale;
    node.hole_height = height / scale;

    return node;
  },

  updateHoleDimensions: function (node, width, depth, height, wall, scale) {
    var childnode = node.hole_child;

    childnode.detach();

    childnode = this.createHoleCylinder(width, depth, height, wall, scale);
    node.hole_child = childnode;
    node.appendChild(childnode);

    node.hole_width = width / scale;
    node.hole_depth = depth / scale;
    node.hole_height = height / scale;
  },

  createHoleFromCursor: function (design, x, y) {
    var transform = this.viewer.getCursorTransform(x, y);

    if (transform == null) {
      return;
    }

    var node_tr = new Sculpteo3DViewerCommonTransform3D(
      design.hollowing.modelNode.transform.toString()
    );

    transform = node_tr.inverse().x(transform);

    var node = this.createHoleWithTransform(
      design.hollowing.holeWidth,
      design.hollowing.holeDepth,
      design.hollowing.holeHeight,
      design.hollowing.wallThickness,
      design.hollowing.scaleFactor,
      transform
    );

    node.design = design;
    var _this = this;
    node.click(function (x, y) {
      if (!_this.cursorON) {
        _this.selectHole(node);
        _this.switchToHoleEdit(_this.selectedHole != null);
      }
    });

    this.addHoleToList(node);
    design.hollowing.hole_container.appendChild(node);
    this.allow_update_sliders = false;
    this.selectHole(node);
    this.allow_update_sliders = true;

    return node;
  },

  updateHoleList: function (design) {
    design.hollowing.holeCount = design.hollowing.holeList.length;
    this.holeCount = design.hollowing.holeCount;
    this.updateHoleUIList();
  },

  addHoleToList: function (node) {
    node.design.hollowing.holeList.push(node);
    this.updateHoleList(node.design);

    this.hole_order_list.push(node);
  },

  removeHoleFromlist: function (node) {
    var idx = node.design.hollowing.holeList.indexOf(node);

    if (idx >= 0) {
      node.design.hollowing.holeList.splice(idx, 1);
      this.updateHoleList(node.design);
    }

    idx = this.hole_order_list.indexOf(node);

    if (idx >= 0) {
      this.hole_order_list.splice(idx, 1);
    }
  },

  clearHoleList: function (design) {
    design.hollowing.holeList.forEach(function (node) {
      node.detach();
    });

    design.hollowing.holeList = [];
    this.updateHoleList(design);

    this.hole_order_list = [];
  },

  initCursor: function () {
    var cursor = this.createHoleCylinder(
      this.parts[0].hollowing.holeWidth,
      this.parts[0].hollowing.holeDepth,
      this.parts[0].hollowing.holeHeight,
      this.parts[0].hollowing.wallThickness,
      this.parts[0].hollowing.scaleFactor
    );

    cursor.setMaterial(this.cursor_material);
    this.viewer.setCursorNode(cursor);
    this.cursorON = true;
  },

  removeCursor: function () {
    this.viewer.setCursorNode(null);
    this.cursorON = false;
  },

  selectHole: function (node, no_ui_update) {
    var _this = this;
    var dfd = $.Deferred();

    function selectNewHole() {
      _this.selectedHole = node;
      _this.selectedHole.setMaterial(_this.hole_selected_material);
      node.design.hollowing.holeWidth =
        node.hole_width * node.design.hollowing.scaleFactor;
      node.design.hollowing.holeDepth =
        node.hole_depth * node.design.hollowing.scaleFactor;
      node.design.hollowing.holeHeight =
        node.hole_height * node.design.hollowing.scaleFactor;

      if (!no_ui_update) {
        _this.switchToHoleEdit(true);
        _this.updateHoleSlidersVal();
      }

      dfd.resolve();

      // $("#DeleteHoleButton").show();
    }

    function selectNoHole() {
      _this.selectedHole = null;
      _this.switchToHoleEdit(false);
      dfd.resolve();
    }

    if (this.selectedHole == node || node == null) {
      if (this.selectedHole != null) {
        if (this.holeModified) {
          this.enableEditingHolesInteraction(false);
          this.updateScriptOperation(
            _this.selectedHole.design,
            false,
            true
          ).then(function () {
            if (_this.selectedHole) {
              _this.selectedHole.setMaterial(_this.hole_material);
            }

            selectNoHole();

            if (!no_ui_update) {
              _this.enableEditingHolesInteraction(true);
            }
          });
        } else {
          this.selectedHole.setMaterial(this.hole_material);
          selectNoHole();
        }
      } else {
        selectNoHole();
      }
    } else {
      if (this.selectedHole != null) {
        if (this.holeModified) {
          this.enableEditingHolesInteraction(false);
          this.updateScriptOperation(
            _this.selectedHole.design,
            false,
            true
          ).then(function () {
            if (_this.selectedHole) {
              _this.selectedHole.setMaterial(_this.hole_material);
            }

            selectNewHole();

            if (!no_ui_update) {
              _this.enableEditingHolesInteraction(true);
            }
          });
        } else {
          this.selectedHole.setMaterial(this.hole_material);
          selectNewHole();
        }
      } else {
        selectNewHole();
      }
    }

    return dfd.promise();
  },

  updateSelectedHoleDimensions: function () {
    if (this.selectedHole != null) {
      this.holeModified = true;
      this.updateHoleDimensions(
        this.selectedHole,
        this.selectedHole.design.hollowing.holeWidth,
        this.selectedHole.design.hollowing.holeDepth,
        this.selectedHole.design.hollowing.holeHeight,
        this.selectedHole.design.hollowing.wallThickness,
        this.selectedHole.design.hollowing.scaleFactor
      );
    }
  },

  updateLastHoleDimensions: function () {
    if (this.hole_order_list.length == 0) {
      return;
    }

    this.viewer.setLocal(true);
    this.holeModified = true;
    var hole = this.hole_order_list[this.hole_order_list.length - 1];

    this.updateHoleDimensions(
      hole,
      hole.design.hollowing.holeWidth,
      hole.design.hollowing.holeDepth,
      hole.design.hollowing.holeHeight,
      hole.design.hollowing.wallThickness,
      hole.design.hollowing.scaleFactor
    );
    var _this = this;

    this.updateScriptOperation(hole.design, false, false).then(function () {
      _this.viewer.setLocal(false);
      _this.on_update_hole();
    });
  },

  updateAllHolesDimensions: function () {
    var dfds = [];

    for (var did in this.parts) {
      var design = this.parts[did];

      if (design.hollowing.holeList.length == 0) {
        continue;
      }

      this.viewer.setLocal(true);
      this.holeModified = true;
      design.hollowing.holeList.forEach(function (hole) {
        this.updateHoleDimensions(
          hole,
          design.hollowing.holeWidth,
          design.hollowing.holeDepth,
          design.hollowing.holeHeight,
          design.hollowing.wallThickness,
          design.hollowing.scaleFactor
        );
      });

      var _this = this;
      var dfd = $.Deferred();

      dfds.push(dfd);
      (function (design, dfd) {
        _this.updateScriptOperation(design, false, false).then(function () {
          dfd.resolve();
        });
      })(design, dfd);
    }

    $.when.apply(null, dfds).then(function () {
      _this.viewer.setLocal(false);
      _this.on_update_hole();
    });
  },

  updateHolesWallThicknes: function () {
    var dfds = [];

    for (var did in this.parts) {
      var design = this.parts[did];

      if (design.hollowing.holeList.length == 0) {
        continue;
      }

      this.viewer.setLocal(true);
      var _this = this;

      design.hollowing.holeList.forEach(function (node) {
        var width = node.hole_width * design.hollowing.scaleFactor;
        var depth = node.hole_depth * design.hollowing.scaleFactor;
        var height = node.hole_height * design.hollowing.scaleFactor;

        _this.updateHoleDimensions(
          node,
          width,
          depth,
          height,
          design.hollowing.wallThickness,
          design.hollowing.scaleFactor
        );
      });

      var dfd = $.Deferred();

      dfds.push(dfd);
      (function (design, dfd) {
        _this.updateScriptOperation(design, false, false).then(function () {
          dfd.resolve();
        });
      })(design, dfd);
    }

    $.when.apply(null, dfds).then(
      function () {
        this.viewer.setLocal(false);
        this.on_update_hole();
      }.bind(this)
    );
  },

  updateHoleParams: function () {
    switch (this.options["hole_update_type"]) {
      case 0: {
        if (this.selectedHole == null) {
          if (this.cursorON) {
            this.initCursor();
          }
        } else {
          this.updateSelectedHoleDimensions();
        }

        break;
      }

      case 1: {
        if (this.cursorON) {
          this.initCursor();
        } else {
          this.updateLastHoleDimensions();
        }

        break;
      }

      case 2: {
        this.updateAllHolesDimensions();
        break;
      }
    }
  },

  /**********************
   * UI Update functions
   **********************/

  getValueInPartUnits: function (val) {
    return (
      (val * this.parts[0].size.units["cm"]) /
      this.parts[0].size.units[this.parts[0].size.unit]
    );
  },

  getValueInBackendUnit: function (val) {
    return (
      (val * this.parts[0].size.units[this.parts[0].size.unit]) /
      this.parts[0].size.units["cm"]
    );
  },

  formatUnitValue: function (val) {
    val = this.getValueInPartUnits(val);

    return val.toFixed(4).toString() + this.parts[0].size.unit;
  },

  formatIntValue: function (val) {
    return (" " + val).slice(-3);
  },

  enableUIComponents: function (enable) {
    if (this.options["thickness_slider"]) {
      $(this.options["thickness_slider"]).slider("option", "disabled", !enable);
    }

    if (this.options["step_slider"]) {
      $(this.options["step_slider"]).slider("option", "disabled", !enable);
    }

    if (this.options["hole_width_slider"]) {
      $(this.options["hole_width_slider"]).slider(
        "option",
        "disabled",
        !enable
      );
    }

    if (this.options["hole_depth_slider"]) {
      $(this.options["hole_depth_slider"]).slider(
        "option",
        "disabled",
        !enable
      );
    }

    if (this.options["hole_height_slider"]) {
      $(this.options["hole_height_slider"]).slider(
        "option",
        "disabled",
        !enable
      );
    }

    if (
      this.options["add_hole_button"] &&
      !(this.options["add_hole_button"] instanceof jQuery)
    ) {
      this.options["add_hole_button"].setDisabled(!enable);
    }

    if (
      this.options["done_hole_button"] &&
      !(this.options["done_hole_button"] instanceof jQuery)
    ) {
      this.options["done_hole_button"].setDisabled(!enable);
    }

    if (
      this.options["delete_selected_hole_button"] &&
      !(this.options["delete_selected_hole_button"] instanceof jQuery)
    ) {
      this.options["delete_selected_hole_button"].setDisabled(!enable);
    }

    if (
      this.options["delete_last_hole_button"] &&
      !(this.options["delete_last_hole_button"] instanceof jQuery)
    ) {
      this.options["delete_last_hole_button"].setDisabled(!enable);
    }

    if (
      this.options["create_holes_button"] &&
      !(this.options["create_holes_button"] instanceof jQuery)
    ) {
      this.options["create_holes_button"].setDisabled(!enable);
    }

    if (
      this.options["start_editing_button"] &&
      !(this.options["start_editing_button"] instanceof jQuery)
    ) {
      this.options["start_editing_button"].setDisabled(!enable);
    }

    if (
      this.options["reset_button"] &&
      !(this.options["reset_button"] instanceof jQuery)
    ) {
      this.options["reset_button"].setDisabled(!enable);
    }

    if (enable) {
      if (this.options["thickness_input"]) {
        $(this.options["thickness_input"]).removeClass("disabled");
      }

      if (
        this.options["add_hole_button"] &&
        this.options["add_hole_button"] instanceof jQuery
      ) {
        this.options["add_hole_button"].removeClass("disabled");
      }

      if (
        this.options["done_hole_button"] &&
        this.options["done_hole_button"] instanceof jQuery
      ) {
        this.options["done_hole_button"].removeClass("disabled");
      }

      if (
        this.options["delete_selected_hole_button"] &&
        this.options["delete_selected_hole_button"] instanceof jQuery
      ) {
        this.options["delete_selected_hole_button"].removeClass("disabled");
      }

      if (
        this.options["delete_last_hole_button"] &&
        this.options["delete_last_hole_button"] instanceof jQuery
      ) {
        this.options["delete_last_hole_button"].removeClass("disabled");
      }

      if (
        this.options["create_holes_button"] &&
        this.options["create_holes_button"] instanceof jQuery
      ) {
        this.options["create_holes_button"].removeClass("disabled");
      }

      if (
        this.options["start_editing_button"] &&
        this.options["start_editing_button"] instanceof jQuery
      ) {
        this.options["start_editing_button"].removeClass("disabled");
      }

      if (
        this.options["reset_button"] &&
        this.options["reset_button"] instanceof jQuery
      ) {
        this.options["reset_button"].removeClass("disabled");
      }
    } else {
      if (this.options["thickness_input"]) {
        $(this.options["thickness_input"]).addClass("disabled");
      }

      if (
        this.options["add_hole_button"] &&
        this.options["add_hole_button"] instanceof jQuery
      ) {
        this.options["add_hole_button"].addClass("disabled");
      }

      if (
        this.options["done_hole_button"] &&
        this.options["done_hole_button"] instanceof jQuery
      ) {
        this.options["done_hole_button"].addClass("disabled");
      }

      if (
        this.options["delete_selected_hole_button"] &&
        this.options["delete_selected_hole_button"] instanceof jQuery
      ) {
        this.options["delete_selected_hole_button"].addClass("disabled");
      }

      if (
        this.options["delete_last_hole_button"] &&
        this.options["delete_last_hole_button"] instanceof jQuery
      ) {
        this.options["delete_last_hole_button"].addClass("disabled");
      }

      if (
        this.options["create_holes_button"] &&
        this.options["create_holes_button"] instanceof jQuery
      ) {
        this.options["create_holes_button"].addClass("disabled");
      }

      if (
        this.options["start_editing_button"] &&
        this.options["start_editing_button"] instanceof jQuery
      ) {
        this.options["start_editing_button"].addClass("disabled");
      }

      if (
        this.options["reset_button"] &&
        this.options["reset_button"] instanceof jQuery
      ) {
        this.options["reset_button"].addClass("disabled");
      }
    }
  },

  enableEditingHolesInteraction: function (enable) {
    this.enableUIComponents(enable);

    /* Comment whole block out, not just contents
		if (enable) {
			$("#DoneHoleButton").removeClass("disabled");
			$("#DeleteHoleButton").removeClass("disabled");
			$("#WidthSliderControl").removeClass("disabled");
			$("#DepthSliderControl").removeClass("disabled");
			$("#HeightSliderControl").removeClass("disabled");
		} else {
			/*			$("#DoneHoleButton").addClass("disabled");
						$("#DeleteHoleButton").addClass("disabled");
						$("#WidthSliderControl").addClass("disabled");
						$("#DepthSliderControl").addClass("disabled");
						$("#HeightSliderControl").addClass("disabled");
		}
		*/
  },

  switchToHoleEdit: function (edit) {
    /* Comment whole block out, not just contents
		if (edit) {
			$("#thickness").hide(200);
			$("#hole_edit").show(200);
		} else {
			$("#hole_edit").hide(200);
			$("#thickness").show(200);
		}
		*/
  },

  switchToModelSave: function (edit) {
    /* Comment whole block out, not just contents
		if (edit) {
			$("#thickness").hide(200);
			$("#model_save").show(200);
		} else {
			$("#model_save").hide(200);
			$("#thickness").show(200);
		}
		*/
  },

  updateHoleSlidersVal: function () {
    if (this.options["hole_width_slider"]) {
      $(this.options["hole_width_slider"]).slider(
        "option",
        "value",
        this.parts[0].hollowing.holeWidth
      );
    }

    if (this.options["hole_depth_slider"]) {
      $(this.options["hole_depth_slider"]).slider(
        "option",
        "value",
        this.parts[0].hollowing.holeDepth
      );
    }

    if (this.options["hole_height_slider"]) {
      $(this.options["hole_height_slider"]).slider(
        "option",
        "value",
        this.parts[0].hollowing.holeHeight
      );
    }
  },

  updateWallSlidersVal: function () {
    if (this.options["thickness_slider"]) {
      $(this.options["thickness_slider"]).slider(
        "option",
        "value",
        -this.parts[0].hollowing.wallThickness
      );
    }

    if (this.options["thickness_input"]) {
      $(this.options["thickness_input"]).val(
        -this.parts[0].hollowing.wallThickness
      );
    }

    if (this.options["step_slider"]) {
      $(this.options["step_slider"]).slider("option", "value", this.step);
    }
  },

  updateHoleUIList: function () {
    // $("#holeCount").html(orig_design.hollowing.holeList.length);
  },
};
